import 'normalize.css/normalize.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/select/lib/css/blueprint-select.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';

import moment from 'moment-timezone';
import React from 'react';
import {
  createRoot,
} from 'react-dom/client';
import {
  Provider,
} from 'react-redux';

import App from './App';
import store from './redux';
import * as serviceWorker from './serviceWorker';

moment.tz.setDefault('Asia/Ho_Chi_Minh');

const suppressedWarnings = [
  'Support for defaultProps will be removed from function components in a future major release',
];
const shouldSuppress = (message) => (
  typeof message === 'string'
  && suppressedWarnings.some((warning) => message.includes(warning))
);
const originalConsoleWarn = console.warn;
const originalConsoleError = console.error;
console.warn = (...args) => {
  if (shouldSuppress(args[0])) {
    return;
  }
  originalConsoleWarn(...args);
};
console.error = (...args) => {
  if (shouldSuppress(args[0])) {
    return;
  }
  originalConsoleError(...args);
};

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
  );
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
